const isProduction = !window.location.href.includes('localhost');

export default isProduction;